import { render } from "./CoursePaymentView.vue?vue&type=template&id=8298b260&scoped=true"
import script from "./CoursePaymentView.vue?vue&type=script&lang=js"
export * from "./CoursePaymentView.vue?vue&type=script&lang=js"

import "./CoursePaymentView.vue?vue&type=style&index=0&id=8298b260&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8298b260"]])

export default __exports__